export interface IGeoCodeResponse {
    data: {
        plus_code: {
            compound_code: string,
            global_code: string
        },
        results: {
            types: string[],
            plus_code: {
                compound_code: string,
                global_code: string
            },
            place_id: string,
            geometry: {
                location: {
                    lat: number,
                    lng: number
                },
                location_type: string,
                viewport: any
            }[],
            formatted_address: string,
            address_components: {
                long_name: string,
                short_name: string,
                types: string[]
            }[]
        }[],
        status: string,
    }
}